
import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { getCouponFrequencies } from '../../../../../../../../../helpr/listingFormData';
import { InputTitleTooltip, TextInput, TextArea, RadioButton, CurrencyInput, DropDown, InputGroup, DateInput } from '../../../../../../../../../components/form/form';

const CouponFrequency = ({ index, securityFormState }) => {
  const { getTextFieldProps, getRadioButtonProps, getTextAreaProps, getField } = securityFormState;
  const renderDatesField = () => {
    if(['MONTHLY', 'QUARTERLY', 'SEMI-ANNUAL', 'ANNUAL'].includes(getField('couponFrequency'))){
      return (
        <>
          <Row className="mt-1">
            <Col md="8">
              <TextArea inputProps={getTextFieldProps('couponPaymentDate')} maxLength="500">
                Coupon Payment Dates (Note: Please use the date format yyyy-mm-dd and ensure dates are separated by commas)
              </TextArea>
            </Col>
          </Row>
          <Row className="mt-1">
            <Col sm={6} lg={4}>
              <DateInput inputProps={getTextFieldProps('couponFirstPaymentDate')}>
                First Payment Date:*
              </DateInput>
            </Col>
          </Row>
          <Row className="mt-1">
            <Col sm={6} lg={3}>
              <InputTitleTooltip title="Record Date:*">
                Two (2) Business Days immediately preceding such relevant Payment Date, which shall be the cut-off date in determining the existing Bondholders
                entitled to receive interest, principal and other payments due, or such other date duly notified by the Issuer.
              </InputTitleTooltip>
              <TextInput inputProps={getTextFieldProps('couponRecordDate')} placeholder="2 Business Days" disabled/>
            </Col>
            <Col sm={6} lg={5}>
              <InputTitleTooltip title="Closed Date:*">
                Two (2) business days prior to the relevant Payment Date
              </InputTitleTooltip>
              <TextInput inputProps={getTextFieldProps('couponClosedPeriod')} placeholder="Exclusive of Payment Date" disabled/>
            </Col>
          </Row>
        </>
      )
    }
  }

  return (
    <>
      <Row className="mt-1">
        <Col md="8">
          <RadioButton nameIndex={index} inputProps={getRadioButtonProps('couponFrequency')} data={getCouponFrequencies()} othersOption={true}/>
        </Col>
      </Row>
      { renderDatesField() }
    </>
  )
}

export default CouponFrequency;



